import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import {
  getPhysicalShipments,
  getLoading,
} from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByPhysicalShipments,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-physical-shipment-count',
    templateUrl: './aggregated-amounts-physical-shipment-count.component.html',
    styleUrls: ['./aggregated-amounts-physical-shipment-count.component.scss'],
    standalone: false
})
export class AggregatedAmountsPhysicalShipmentCountComponent implements OnInit {
  physicalShipmentCountModel$: Observable<CountableSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.physicalShipmentCountModel$ = this.store.select(getPhysicalShipments)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByPhysicalShipments)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
